<template>
  <div class="container">
    <form accept-charset="UTF-8" role="form" @submit.stop.prevent="handleSubmit">
      <h1>{{ title }}</h1>
      <p class="text-muted">{{ msg }}</p>
      <p class="text-muted">{{ this.$passwordRequirements }}</p>
      <div class="alert alert-success" v-show="successMessage">
        {{ successMessage }}
      </div>
      <div class="alert alert-danger" v-show="errorMessage">
        {{ errorMessage }}
      </div>

      <fieldset>
        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input name="newPassword" class="form-control"
                 placeholder="new password" type="password" v-model="newPassword" min="8"
                 v-validate="'required|min:8|contains_alpha_lower|contains_alpha_upper|contains_number'"
                 data-vv-as="password"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('newPassword')" class="invalid-feedback">{{ validate_errors.first('newPassword') }}</div>
        </div>

        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input name="newPasswordConfirmation" class="form-control"
                 placeholder="confirm password" type="password"
                 v-validate="'required|confirmed:newPassword'"
                 data-vv-as="confirm password"
                 v-model="newPasswordConfirmation" min="8" :disabled="disableAllInputs">
          <div v-show="validate_errors.has('newPasswordConfirmation')" class="invalid-feedback">{{ validate_errors.first('newPasswordConfirmation') }}</div>
        </div>

        <input class="btn btn-primary px-4" type="submit" value="Save New Password"
               :disabled="protectedUI || !formIsValid || disableAllInputs">
      </fieldset>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'PasswordChallenge',
    data: () => ({
      title: 'Set Up Password',
      msg: 'This is your first time logging in.  You must set a password to continue.',
      errorMessage: null,
      successMessage: null,
      disableAllInputs: false,
      protectedUI: false,
      newPassword: '',
      newPasswordConfirmation: ''
    }),
    props: ['forwarded'],
    methods: {
      handleSubmit () {
        // Remove alert boxes
        this.successMessage = null
        this.errorMessage = null

        this.protectedUI = true
        this.$store.dispatch('completeNewPasswordChallenge', {
          newPassword: this.newPassword,
          userAttributes: []
        }).then((result) => {
          this.disableAllInputs = true
          this.successMessage = 'Password successfully changed'
          this.password = ''
          this.errorMessage = null
          this.$router.push({ path: '/' })
        }).catch((err) => {
          this.$raven.captureException(err)
          this.errorMessage = err.message
          this.protectedUI = false
        })
      },
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      }
    },
    computed: {
      formIsValid () {
        return Object.keys(this.fields).every(key => this.fields[key].valid)
      }
    },
    created: function () {
      if (this.forwarded === undefined || this.forwarded !== true) {
        console.log('forward to login')
        // this.$router.push({ name: 'Login' })
      }
    }
  }
</script>

<style scoped>
  .input-group {
    flex-wrap: wrap;
    flex-direction: row;
  }
  .input-group input.form-control {
    width: 70%;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/PasswordChallenge.vue?627f91cb